import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=b46d769a"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports